import { render, staticRenderFns } from "./AlibabaOrder.vue?vue&type=template&id=3370c8de"
import script from "./AlibabaOrder.vue?vue&type=script&lang=js"
export * from "./AlibabaOrder.vue?vue&type=script&lang=js"
import style0 from "./AlibabaOrder.vue?vue&type=style&index=0&id=3370c8de&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.27_cache-loader@2.0.1_webpack@4.47.0__css-load_e3fe5bc08730b116179cfe735040894c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports